<template>
    <div>
        <div class="row">
            <div class="col-12" sm="12">
                <div class="card">
                    <div class="card-header">
                        <strong>ثبت خبر</strong>
                        <div class="card-header-actions">
                            <a
                                href="https://coreui.io/vue/docs/components/form-components"
                                class="card-header-action"
                                rel="noreferrer noopener"
                                target="_blank"
                            >
                                <small class="text-muted"></small>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div  class="col-4">
                              <div class="form__group">

                                <input
                                    v-model="title"

                                    label="عنوان خبر"
                                    placeholder="عنوان"
                                    vertical
                                />
                                {{title}}
                                <CInput
                                    v-model="title"

                                    label="عنوان خبر"
                                    placeholder="عنوان"
                                  />
                              </div>
                            </div>
                            <div  class="col-4" sm="4">
                                <input
                                        v-model="seo_title"

                                        label="سئو عنوان"

                                />

                            </div>
                            <div  class="col-4" sm="4">
                                <input
                                        v-model="favorite_url"
                                        label="لینک خبر"

                                        placeholder="لینک"
                                />

                            </div>
                        </div>

<!--                        <CRow>-->
<!--                            <CCol sm="12">-->
<!--                                <ckeditor-->
<!--                                    v-model="editorData"-->
<!--                                    :editor-url="editorUrl"-->
<!--                                ></ckeditor>-->


<!--                            </CCol>-->
<!--                        </CRow>-->
                        <div class="row">
                            <div class="col-12" sm="12">
<!--                                <Vueditor style="height: 400px" id="editor1" ref="editor1"></Vueditor>-->

                              <ckeditor style="height: 400px" :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>


                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12" sm="12">
                                <textarea
                                    v-model="seo_summary"

                                    label="سئو توضیحات"

                                ></textarea>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4" sm="4">

                                <treeselect
                                    v-model="value_tags"
                                    :multiple="true"
                                    :async="true"
                                    :load-options="load_tags"
                                    placeholder="انتخاب برچسب ها"
                                    :normalizer="normalizer_tags"
                                />


                            </div>
                            <div class="col-4" sm="4">
                                <treeselect
                                        v-model="value_keywords"
                                        :multiple="true"
                                        :async="true"
                                        :load-options="load_keywords"
                                        placeholder="انتخاب کلمات کلیدی"
                                        :normalizer="normalizer_keywords"
                                />


                            </div>
                            <div class="col-4" sm="4">
                                    <treeselect
                                            v-model="value_category"
                                            :multiple="true"
                                            :normalizer="normalizer_category"

                                            :options="options_category"
                                            placeholder="دسته بندی خبر را انتخاب کنید"
                                    />


                            </div>
                        </div>
                        <br>

                        <div class="row">
                            <label>تصویر خبر</label>
<br>
                            <div class="col-6" sm="6">

                                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                            </div>
                                <div class="col-6" sm="6">

                                  <ImageSelector label="تصویر"
                                                 v-model:previewImage="previewImage"
                                                 @imagefile="(n) => file = n"
                                  />

                                </div>


                        </div>


                    </div>
                    <div>
                        <button v-if="status_form==0" @click="login()" type="submit" ref="submit_form" size="sm" color="primary">
                            ثبت خبر
                        </button>
                        <button v-if="status_form!=0" @click="login()" type="submit" ref="submit_form" size="sm" color="primary">
                            ویرایش خبر
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import axios from "axios";
import CInput from "@/views/CustomComponent/CInput.vue";
    import Treeselect, {ASYNC_SEARCH} from 'vue3-treeselect'
    import 'vue3-treeselect/dist/vue3-treeselect.css'
    import ImageSelector from "@/views/CustomComponent/ImageSelector.vue";
    // import the styles
    const simulateAsyncOperation = fn => {
      setTimeout(fn, 200)
    }
    var items_role = [];
    const fields_role = [
        {key: 'نام', _style: 'width:20%'},
        {key: 'دسترسی', _style: 'width:20%'},


    ];
    var items_group = [];


    const fields_group = [
        {key: 'نام', _style: 'width:20%'},
        {key: 'دسترسی', _style: 'width:20%'},


    ];
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    export default {
        name: 'Login',
        components: {
          ImageSelector,
            Treeselect,
          CInput,

            // ckeditor: CKEditor.component
        },
        data() {

            return {
              editor: ClassicEditor,

                value_category: [],
                value_tags: [],
                value_keywords: [],
                // define options
                image_upload: '',
                options_category: [{
                    cat_id: 'a',
                    name: 'a',
                    subcategories: [{
                        cat_id: 'aa',
                        name: 'aa',
                    }, {
                        cat_id: 'ab',
                        name: 'ab',
                    }],

                }, {
                    cat_id: 'b',
                    name: 'b',
                }, {
                    cat_id: 'c',
                    name: 'c',
                }],
                normalizer_category(node) {
                    return {
                        id: node.cat_id,
                        label: node.name,
                        children: node.subcategories,
                    }
                },
                load_keywords({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            axios.post('/api/admin/search-keywords', {
                                search: searchQuery,

                            }).then(function (response) {
                                options = response.data;
                                callback(null, options);
                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_keywords(node) {
                    return {
                        id: node.keyword_title,
                        label: node.keyword_title,
                    }
                },
                load_tags({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            axios.post('/api/admin/search-tags', {
                                search: searchQuery,

                            }).then(function (response) {
                                options = response.data;
                                callback(null, options);
                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_tags(node) {
                    return {
                        id: node.tag_title,
                        label: node.tag_title,
                    }
                },
                // editor: ClassicEditor,
                editorData: '',
                editorConfig: {
                    extraPlugins: [

                                     ],

                    language: 'fa'
                    // The configuration of the editor.
                },
                title: '',
                favorite_url: '',
                seo_title: '',
                summary: '',
                seo_summary: '',
                tags: '',
                keywords: '',
                file: '',

                previewImage: '',
                image: '',
                group_items: items_group.map((item, id) => {
                    return {...item, id}
                }),
                fields_group,
                role_items: items_role.map((item, id) => {
                    return {...item, id}
                }),
                fields_role,
                details: [],
                collapseDuration: 0,
                status_form: 0,
                options: [
                    {text: 'One', value: 'A'},
                    {text: 'Two', value: 'B'},
                    {text: 'Three', value: 'C'}
                ]
            }
        },
        mounted() {
            //  this.editor = this.$refs['editor1'];
            // this.editor.setContent('');
            // this.editor.getContent();
            // this.editor.upload = function (obj, callback) {
            //     let formData = new FormData();
            //     let xhr = new XMLHttpRequest();
            //
            //     formData.append('upload', obj.files[0]);
            //     xhr.open('POST', 'https://furnishium.com/api/admin/uploader2');
            //     // xhr.setRequestHeader('Content-type', 'application/json')
            //
            //     xhr.send(formData);
            //     xhr.onload = function () {
            //         callback(xhr.responseText);
            //     };
            //     xhr.onerror = function (err) {
            //         console.log(err);
            //     }
            // }
            this.get_categories();
            this.get_roles();
            if (this.$route.params.post_id != null) {
                this.status_form = this.$route.params.post_id;
                this.get_post_info();
            }
        }, watch: {
            '$route.params.post_id': function (id) {
                this.get_categories();
            }
        },
        methods: {
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            editDetails(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = this.items[item.id].name
                this.color = this.items[item.id].color
                this.description = this.items[item.id].description
                this.previewImage = this.items[item.id].image
                this.status_form = this.items[item.id].cat_id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_categories() {
                var self = this;

                axios.get('/api/all-categories', {}).then(function (response) {
                    // console.log("cats is "+response.data.groups);
                    // console.log("cats is "+items);

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    self.options_category = content_cats.data;
                    // console.log("cats is "+items);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_keywords(search) {
                var self = this;
                axios.post('/api/admin/search-keywords', {
                    search: search,

                }).then(function (response) {
                    return response.data
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
            get_post_info() {
                var self = this;
                var formData = new FormData();
                formData.append('post_id',self.status_form);
                axios.post('/api/admin/post_info',formData, {}).then(function (response) {
                    var post_data =  response.data;

                    self.previewImage = post_data.post.image;
                    post_data.post.categories.forEach((val)=>{
                        self.value_category.push(val.cat_id);
                    });
                    post_data.post.tags.forEach((val)=>{
                        self.value_tags.push(val.name);
                    });
                    post_data.post.keywords.forEach((val)=>{
                        self.value_keywords.push(val.name);
                    });
                    // self.value_category = post_data.post.categories;
                    //  self.options_=post_data.post.tags;
                     // self.value_keywords=post_data.post.keywords;
                    self.title=post_data.post.title;
                    self.favorite_url=post_data.post.favorite_url;
                    self.editorData=post_data.post.summary;
                    self.editor.setContent(post_data.post.summary)
                    self.seo_summary=post_data.post.meta_description;
                    self.seo_title=post_data.post.seo_title;

                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                }).catch(function (error) {

                        console.log(error);
                    });


            },
            goRegister() {
                this.$router.push({path: 'register'});
            },
            goSubCategories(item, index) {

                this.$router.push({path: '/categories/' + this.items[index].cat_id});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            get_roles() {
                var self = this;

                axios.get('/api/admin/roles', {}).then(function (response) {

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    self.role_items = content_cats.permissions.map((item, id) => {
                        return {...item, id}
                    }),
                        fields_role;
                    // console.log("cats is "+items);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.previewImage = e.target.result;
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);
                }
            },
            login() {
                let self = this;
                const formData = new FormData()
                let url;
                if (self.status_form == 0) {
                    url = "/api/admin/post";
                } else {
                    url = "/api/admin/post/update";
                    formData.append('post_id', this.status_form)

                }

                formData.append('post_image', this.file)
                formData.append('form_post_cat_list', this.value_category)
                formData.append('form_post_tags', this.value_tags)
                formData.append('form_post_keywords', this.value_keywords)
                formData.append('form_post_name', this.title)
                formData.append('form_post_url', this.favorite_url)
                formData.append('form_post_text', this.editor.getContent())
                formData.append('form_post_meta_desc', this.seo_summary)
                formData.append('form_post_meta_title', this.seo_title)
                // formData.append('is_admin', 1)
                // formData.append('role_group', this.selected_group)
                // formData.append('roles', self.$refs.permissions)
                axios.post(url, formData, {}).then((res) => {
                    console.log(res)
self.$root.modal_component.show_api_response_modals(res);
if(self.status_form==0){
    self.name = '';
    self.mobile = '';
    self.email = '';
    self.description = '';
    self.password = '';
    self.selected_group = '0';
    self.permissions = [];
}

                }).catch(function (error) {

                    console.log(error);
                });

            }
        }
    }


</script>
<style>

</style>
